import styled from '@emotion/styled';
import { Stack } from '@hotjar/hotsauce';
import { InvitationCustomization } from './Customization/InvitationCustomization';
import { InvitationPreview } from './Preview/InvitationPreview';

export type Invitation = {
  title: string;
  description: string;
  button: string;
  close: string;
};

export type SurveyInvitationProps = {
  invitation: Invitation;
  isInvitationEnabled: boolean;
  onInvitationChange: (invitation: Invitation) => void;
  setInviteEnabled: (inviteEnabled: boolean) => void;
  showBranding: boolean;
};

const Wrapper = styled(Stack)`
  gap: 0;
  max-width: 100%;
`;

export const SurveyInvitation = ({
  invitation,
  isInvitationEnabled,
  onInvitationChange,
  setInviteEnabled,
  showBranding,
}: SurveyInvitationProps): JSX.Element => {
  return (
    <Wrapper>
      <InvitationCustomization
        isInvitationEnabled={isInvitationEnabled}
        invitation={invitation}
        onInvitationChange={onInvitationChange}
        setInviteEnabled={setInviteEnabled}
      />

      {isInvitationEnabled && (
        <InvitationPreview invitation={invitation} showBranding={showBranding} />
      )}
    </Wrapper>
  );
};
